import config from '../views/config/App_data';

const API_BASE = config.backend_api;

export const API_ENDPOINT = {
  GET_SENDGRID_STATUS: `${API_BASE}/email/subscription-status`,
  RESUBSCRIBE_SENDGRID: `${API_BASE}/email/resubscribe`,
};



// WEBPACK FOOTER //
// ./src/common/apiEndPoints.js